<template>
  <div class="order">
    <div id="TopTabs" class="content">
      <SearchNav />
      <el-tabs v-model="activeStatus" @tab-click="handerClickStatus">
        <el-tab-pane
          v-for="(tab, index) in tabs"
          :label="tab.title"
          :name="String(tab.name)"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <div class="order__search">
        <el-input v-model="searchValue" size="mini" class="w200 input-with-select" :placeholder="placeholderText">
          <el-select @change="changeOption" v-model="optionType" slot="prepend" placeholder="请选择">
            <el-option label="商品" value="item"></el-option>
            <el-option label="订单" value="orderSn"></el-option>
          </el-select>
        </el-input>
        <el-date-picker
          size="mini"
          class="m_r"
          v-model="timeRange"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <span @click="searchOrderList" class="search__btn center">
          搜索
        </span>
      </div>
      <div class="order_title">
        <div class="store">商品详情</div>
        <div class="item_total">商品总额</div>
        <div class="item_disamount_total">优惠金额</div>
        <div class="total_amount">实付款</div>
        <div class="status">订单状态</div>
        <div class="option">操作</div>
      </div>
      <div v-if="!onStartLoad">
        <template v-if="orderList.length">
          <div v-for="(order, index) in orderList" :key="`order_${index}`" class="item_card">
            <OrderCard
              :key="`card_${index}`"
              :orderInfo="order"
              @confirmOrder="confirmOrder"
              @confirmRefund="confirmRefund"
              @cancelorder="onCancelOrder"
              @contactCustomerService="onContactCustomerService(order)"
              @pay="onPay"
              @showContract="showContract"
            />
          </div>
          <el-pagination
            v-if="orderList.length"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="20"
            :current-page.sync="listParams.pageNum"
            layout="sizes, prev, pager, next"
            :total="totalRecord"
          ></el-pagination>
        </template>
        <template v-else>
          <div class="list-empty">
            <img :src="require('@/assets/img/shop-empty.png')" alt="" />
            <span>暂无订单</span>
          </div>
        </template>
      </div>
    </div>
    <!-- 对公转账弹框 -->
    <PublicDialog @ok="init" :orderDetail="orderDetail" :orderSn="orderDetail.orderSn" ref="publicDialogRef" />
    <Contract ref="Contract"></Contract>
  </div>
</template>

<script>
import OrderCard from './components/OrderCard';
import { isEmpty } from '@/helpers/utils';
import dayjs from 'dayjs';
import PublicDialog from '../OrderDetail/components/PublicDialog.vue';
import VueScrollTo from 'vue-scrollto';
import * as api from '@/services';
import { mapGetters } from 'vuex';
import SearchNav from '@/components/SearchNav';
import Contract from '@/components/contract/index';
import { getTradeInfo } from '@zyf2e/checkout-sdk'

const scrollOptions = {
  container: '.layout-component',
  duration: 200,
  lazy: false,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};
const { ORDER_STATUS } = require('../constants/order');
export default {
  components: { OrderCard, PublicDialog, SearchNav, Contract },
  computed: {
    ...mapGetters({
      groupChat: 'imChatService/getPcGroupChat',
      groupList: 'imChatService/getPcGroupList'
    })
  },
  data() {
    return {
      activeStatus: '',
      onStartLoad: true,
      searchValue: '',
      ORDER_STATUS,
      timeRange: '',
      optionType: 'item',
      placeholderText: '请输入商品名称',
      tabs: [
        {
          title: '全部',
          name: ''
        },
        {
          title: '待支付',
          name: ORDER_STATUS.UNPAYED
        },
        {
          title: '待开户',
          name: ORDER_STATUS.UNAUDITED
        },
        {
          title: '待开单',
          name: ORDER_STATUS.PREDELIVERY
        },
        {
          title: '待配送',
          name: ORDER_STATUS.WAITDELIVER
        },
        {
          title: '配送中',
          name: ORDER_STATUS.DELIVERING
        },
        {
          title: '已完成',
          name: ORDER_STATUS.RECEIVED
        },
        {
          title: '已关闭',
          name: ORDER_STATUS.CANCELLED
        }
      ],
      listParams: {
        pageSize: 20,
        pageNum: 1
      },
      orderList: [],
      error: false,
      finished: false,
      loading: false,
      totalRecord: 0,
      orderDetail: {}
    };
  },
  beforeDestroy() {
    this.$store.dispatch('layout/SET_FOOTER', true);
  },
  mounted() {
    this.$store.dispatch('layout/SET_FOOTER', false);
    this.init();
  },
  methods: {
    showContract(sn) {
      this.$refs.Contract.open(sn);
    },
    changeOption() {
      if (this.optionType === 'item') {
        this.placeholderText = '请输入商品名称';
      }
      if (this.optionType === 'orderSn') {
        this.placeholderText = '请输入订单号';
      }
    },
    handerClickStatus(tab) {
      this.listParams = {
        pageSize: 20,
        pageNum: 1
      };
      this.getOrderList(this.activeStatus);
    },
    handleSizeChange(val) {
      this.listParams = {
        pageSize: val,
        pageNum: 1
      };
      this.getOrderList(this.activeStatus);
    },
    handleCurrentChange(val) {
      this.listParams.pageNum = val;
      this.getOrderList(this.activeStatus);
    },
    async init() {
      this.listParams = {
        pageSize: 20,
        pageNum: 1
      };
      const { orderStatus } = this.$route.query;
      !isEmpty(orderStatus) && (this.activeStatus = String(orderStatus));
      this.getOrderList(this.activeStatus);
    },
    searchOrderList() {
      this.listParams = {
        pageSize: 20,
        pageNum: 1
      };
      this.getOrderList(this.activeStatus);
    },
    // 获取订单列表
    async getOrderList(status = this.activeStatus) {
      this.error = false;
      this.finished = false;
      this.loading = true;
      try {
        const params = {
          ...this.listParams,
          orderStatus: isEmpty(status) || status === '0' ? undefined : status
        };
        if (this.searchValue) {
          params.keyType = this.optionType;
          params.keyword = this.searchValue;
        }

        if (this.timeRange) {
          params.submitOrderTimeStart = dayjs(this.timeRange[0]).format('YYYY-MM-DD');
          params.submitOrderTimeEnd = dayjs(this.timeRange[1]).format('YYYY-MM-DD');
        }
        const res = await api.order.queryOrderList(params);
        if (res.totalPage === 0 || res.totalRecord === 0) {
          this.orderList = [];
          this.loading = false;
          this.onStartLoad = false;
          this.error = true;
          return;
        }
        this.orderList = [...res.list];
        if (res.totalPage === res.pageNum && res.totalRecord != 0) {
          this.finished = true;
        }
        this.totalRecord = res.totalRecord;
        VueScrollTo.scrollTo('.el-header', 150, scrollOptions);
      } catch (error) {
        this.orderList = [];
        this.error = true;
      }
      this.loading = false;
      this.onStartLoad = false;
    },
    onCancelOrder(orderSn) {
      this.$confirm('确定取消订单吗？', {
        confirmButtonText: '取消订单',
        cancelButtonText: '考虑一下',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        title: null,
        alignFooter: 'right',
        type: 'warning'
      })
        .then(async () => {
          await api.order.cancelOrder({ orderSn: orderSn });
          this.$message.success('订单已取消');
          this.listParams = {
            pageSize: 20,
            pageNum: 1
          };
          this.getOrderList(this.activeStatus);
        })
        .catch();
    },
    confirmRefund(orderSn) {
      this.$confirm('确认后订单将自动关闭', {
        cancelButtonText: '取消',
        confirmButtonText: '确认',
        title: '是否已确认收到卖家线下转账的退款？',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        alignFooter: 'right',
        type: 'warning'
      })
        .then(async () => {
          await api.order.confirmRefund({ orderSn: orderSn });
          this.listParams = {
            pageSize: 20,
            pageNum: 1
          };
          this.getOrderList(this.activeStatus);
        })
        .catch();
    },
    confirmOrder(orderSn) {
      this.$confirm('为了保证您的售后权益，请收到商品检查无误后再确认收货', {
        cancelButtonText: '取消',
        confirmButtonText: '确认',
        title: '确认收到货了吗？',
        alignFooter: 'right',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        type: 'warning'
      })
        .then(async () => {
          await api.order.confirmOrder({ orderSn });
          this.listParams = {
            pageSize: 20,
            pageNum: 1
          };
          this.getOrderList(this.activeStatus);
        })
        .catch();
    },
    async onContactCustomerService(order) {
      const res = await api.shop.creatSession({
        storeId: order.merchantId
      });
      const { groupId } = res;
      this.$store.dispatch('imChatService/SET_CHAT_GID', groupId);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        this.groupChat.init();
      });
      this.$store.dispatch('imDialogService/openDialog');
    },
    async onPay(orderDetail) {
      if (orderDetail.payId === 0) {
        // 在线支付
        const payOrderRes = await api.order.payOrder({ orderSn: orderDetail.orderSn });
        this.$router.push(`/pay_onlinePayment/${orderDetail.orderSn}/${payOrderRes.tradeNo}`);
        return
      }
      this.orderDetail = orderDetail;
      const res = await api.order.payOrder({ orderSn: orderDetail.orderSn });
      if (res.forward === 1) {
        this.$alert('请前往app完成微信支付', '提示', {
          confirmButtonText: '确定',
          alignFooter: 'right',
          cancelButtonClass: 'custom_confirm_button',
          confirmButtonClass: 'custom_confirm_button'
        });
      } else {
        this.$refs.publicDialogRef.dialogVisible = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.order {
  height: 100%;
  ::v-deep .el-input-group__prepend {
    background-color: #fff;
    width: 80px;
  }
  .el-tabs {
    margin-top: 24px;
  }
  ::v-deep .el-input__inner {
    border-radius: 0;
    color: #595959;
  }
  ::v-deep .el-input-group__prepend {
    border-radius: 0;
  }

  .fr {
    float: right;
  }
  &__search {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    // overflow: hidden;
    padding-top: 1px;
  }
  .order_title {
    display: flex;
    height: 44px;
    background: #fafafa;
    line-height: 44px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin-bottom: 8px;
    color: #333333;
    div {
      text-align: center;
    }
    .store {
      width: 488px;
    }
    .item_total {
      width: 127px;
    }
    .item_disamount_total {
      width: 127px;
    }
    .total_amount {
      width: 188px;
    }
    .status {
      width: 150px;
    }
    .option {
      width: 151px;
    }
  }
  .item_card {
    margin-bottom: 16px;
    border-bottom: 1px solid #dfdfdf;
  }
  .w200 {
    width: 316px;
    margin-right: 8px;
  }
  .m_r {
    margin-right: 8px;
  }
  // 重置input样式
  .search__btn {
    background: #1e8dff;
    color: #fff;
    cursor: pointer;
    width: 56px;
    height: 28px;
    display: inline-block;
    border-radius: 0;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    // &:hover {
    //   background: #bcddff;
    // }
  }
  .el-pagination {
    text-align: right;
    margin-bottom: 60px;
  }
  .list-empty {
    text-align: center;
    img {
      margin-top: 80px;
      width: 220px;
      height: 220px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 14px;
      margin-top: 8px;
      display: block;
    }
  }
}
::v-deep .el-input__inner {
  color: #595959 !important;
}
</style>
